import { GetterTree } from 'vuex'
import type { RootState } from "store";
import { SettingState } from './types'

export const getters: GetterTree<SettingState, RootState> = {
    payLocationCount: (state: SettingState) => state.paylocationCount,
    settings: (state: SettingState) => state.settings,
}